var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Aedu, rel, ris, undefined) {
buf.push("<div class=\"clearfix\"><ul class=\"list-group ri-list-card-negative-margin\">");
// iterate ris
;(function(){
  var $$obj = ris;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var ri = $$obj[$index];

buf.push("<li class=\"list-group-item padding-top-1x\"><div class=\"text-center btn-toolbar pull-right margin-top-4x ri-list-card-actions\">");
if(Aedu.User.current)
{
var follows = Aedu.User.current && Aedu.User.current.has_interest(ri.id)
buf.push("<a" + (jade.attr("data-follow-ri-id", ri.id, true, true)) + " data-follow-ri-source=\"ri_list_card\"" + (jade.attr("style", (follows ? 'display: none' : false), true, true)) + " class=\"btn btn-xs btn-primary\"><small><div class=\"fa fa-plus\"></div></small></a><a" + (jade.attr("data-unfollow-ri-id", ri.id, true, true)) + (jade.attr("style", (follows ? false : 'display: none'), true, true)) + " class=\"btn btn-xs btn-success-clear\"><small><i class=\"fa fa-check\"></i></small></a>");
}
buf.push("</div><span" + (jade.attr("data-stats-for-ri", ri.id, true, true)) + ">");
rel = (ri.get('nofollow')) ? 'nofollow' : ''
buf.push("<a" + (jade.attr("href", ri.get('url'), true, true)) + (jade.attr("rel", rel, true, true)) + " class=\"margin-top-2x text-truncate link-unstyled h5 margin-bottom-0x padding-bottom-1x padding-right-5x\">" + (jade.escape(null == (jade_interp = ri.get('name')) ? "" : jade_interp)) + "</a><strong data-stat=\"followers_count\" class=\"js-ri-card-stat-num ri-card-stat-label\"><i class=\"fa fa-spinner fa-spin\"></i></strong><span class=\"ri-card-stat-label\"> People</span></span></li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var ri = $$obj[$index];

buf.push("<li class=\"list-group-item padding-top-1x\"><div class=\"text-center btn-toolbar pull-right margin-top-4x ri-list-card-actions\">");
if(Aedu.User.current)
{
var follows = Aedu.User.current && Aedu.User.current.has_interest(ri.id)
buf.push("<a" + (jade.attr("data-follow-ri-id", ri.id, true, true)) + " data-follow-ri-source=\"ri_list_card\"" + (jade.attr("style", (follows ? 'display: none' : false), true, true)) + " class=\"btn btn-xs btn-primary\"><small><div class=\"fa fa-plus\"></div></small></a><a" + (jade.attr("data-unfollow-ri-id", ri.id, true, true)) + (jade.attr("style", (follows ? false : 'display: none'), true, true)) + " class=\"btn btn-xs btn-success-clear\"><small><i class=\"fa fa-check\"></i></small></a>");
}
buf.push("</div><span" + (jade.attr("data-stats-for-ri", ri.id, true, true)) + ">");
rel = (ri.get('nofollow')) ? 'nofollow' : ''
buf.push("<a" + (jade.attr("href", ri.get('url'), true, true)) + (jade.attr("rel", rel, true, true)) + " class=\"margin-top-2x text-truncate link-unstyled h5 margin-bottom-0x padding-bottom-1x padding-right-5x\">" + (jade.escape(null == (jade_interp = ri.get('name')) ? "" : jade_interp)) + "</a><strong data-stat=\"followers_count\" class=\"js-ri-card-stat-num ri-card-stat-label\"><i class=\"fa fa-spinner fa-spin\"></i></strong><span class=\"ri-card-stat-label\"> People</span></span></li>");
    }

  }
}).call(this);

buf.push("</ul></div>");}.call(this,"Aedu" in locals_for_with?locals_for_with.Aedu:typeof Aedu!=="undefined"?Aedu:undefined,"rel" in locals_for_with?locals_for_with.rel:typeof rel!=="undefined"?rel:undefined,"ris" in locals_for_with?locals_for_with.ris:typeof ris!=="undefined"?ris:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}